// @ts-ignore
import React from "react";

import styled from "@emotion/styled";

import Spinner from "@atlaskit/spinner";

export const LoadingState = () => (
    <SpinnerWrapper>
        <Spinner />
    </SpinnerWrapper>
);

const SpinnerWrapper = styled.div`
    width: 100%;
    height: 100%;
    min-height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
`;
